import type { ReactNode } from "react";

type PageHeaderProps = {
	title: string;
	description?: string;
	actions?: ReactNode;
};

const PageHeader: React.FC<PageHeaderProps> = ({ title, description, actions }) => (
	<div className="flex flex-wrap items-start justify-between gap-4">
		<div className="flex flex-col gap-1">
			<h1 className="text-2xl font-bold text-foreground">{title}</h1>
			{description ? <p className="text-sm text-muted">{description}</p> : null}
		</div>
		{actions ? <div className="flex items-center gap-2">{actions}</div> : null}
	</div>
);

export default PageHeader;
